import { Controller } from "@hotwired/stimulus";
import Cocooned from "@notus.sh/cocooned";

export default class extends Controller {
  connect() {
  }

  close() {
    this.element.remove();
  }
}
